// extracted by mini-css-extract-plugin
export default {"previousSummaries":"styles_previousSummaries__J1H7f","date":"styles_date__JjFed"};